import controller from './access.controller';

const template = require('./access.html');

export default {
    controller,
    template
};



// WEBPACK FOOTER //
// ./app/common/access-management/access.component.js